import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { MissionSection } from "../components/Mission";
import { Link } from "react-router-dom";

const About = () => {
  useDocTitle("ZelT | About Us");

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 lg:mx-20 max-w-4xl mx-auto">
          <h1
            className="text-4xl md:text-5xl font-extrabold text-blue-900 text-center mb-6"
            data-aos="zoom-in"
          >
            Technology in Service of People
          </h1>
          <p className="text-lg text-gray-600 text-center mb-12" data-aos="fade-up">
            ZelTechnology is a nonprofit organization based in San Diego,
            California. We believe everyone deserves honest, patient, and free
            help with technology — regardless of income, age, or background.
          </p>

          <div className="space-y-10" data-aos="fade-up">
            <section>
              <h2 className="text-2xl font-bold text-blue-900 mb-3">Our Story</h2>
              <p className="text-gray-600 leading-relaxed">
                ZelTechnology was founded on a simple observation: the people
                who need technology help the most — seniors on fixed incomes,
                struggling families, small dreamers with big ideas — are
                charged the most for it. Predatory repair shops, scareware,
                and tech support scams target exactly those who can least
                afford to lose money or data.
              </p>
              <p className="text-gray-600 leading-relaxed mt-4">
                We decided to flip the equation. Our team — home to
                like-minded individuals who have served our country, alongside
                mission-driven technologists — provides free IT services,
                security guidance, and now AI-powered tools through our LAMNA
                platform. Service didn't stop when the uniform came off; it
                just changed mission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-900 mb-3">What We Do</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Free computer help, guidance, and troubleshooting for members</li>
                <li>Security awareness — protecting people from scams and predators</li>
                <li>IT consultation for small businesses and nonprofits that can't afford it</li>
                <li>LAMNA — our AI assistant platform, built for the community</li>
                <li>Education and training through community partners</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-900 mb-3">Where We Serve</h2>
              <p className="text-gray-600 leading-relaxed">
                Headquartered in San Diego, California (11160 Rancho Carmel
                Dr STE 106, #1055, San Diego, CA 92128), with a focus on
                North County and the greater San Diego community. Our digital
                doors are open to everyone.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-blue-900 mb-3">
                Transparency
              </h2>
              <p className="text-gray-600 leading-relaxed">
                Trust is earned with openness. ZelTechnology is a registered
                nonprofit organization; our IRS Form 990 filings and annual
                reports are available on request via{" "}
                <b>support@zeltechnology.org</b>. Our current-year finances
                are published openly on the{" "}
                <Link to="/transparency" className="text-blue-900 font-semibold underline">
                  Transparency page
                </Link>
                .
              </p>
              <p className="text-gray-500 text-sm mt-3">
                Partner programs we refer members to (such as Compudopt and
                Human-I-T) publish their own filings on their sites —
                transparency across the whole chain.
              </p>
            </section>
          </div>

          <div
            className="mt-12 rounded-2xl p-8 text-center text-white shadow-xl"
            style={{ background: "linear-gradient(90deg, #36395a, #1e3a8a)" }}
          >
            <p className="text-xl font-semibold">
              Ready to get help — or give it?
            </p>
            <Link
              to="/membership"
              className="inline-block mt-4 px-6 py-3 rounded-xl bg-teal-400 text-blue-900 font-bold hover:bg-teal-300 transition"
            >
              Become a Free Member
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
